const isFilterActive = (value: unknown): boolean =>
  value !== null && !(Array.isArray(value) && value.length === 0);

export const countActiveFilters = <TFilters extends Record<string, unknown>>(
  filters: TFilters,
  defaults: TFilters,
  excludeKeys: readonly (keyof TFilters)[],
): number =>
  (Object.keys(defaults) as (keyof TFilters)[])
    .filter((key) => !excludeKeys.includes(key) && isFilterActive(filters[key]))
    .length;
